module.exports = __webpack_public_path__ + "static/media/ujwal.1f282f15.jpg";